import type { Field } from './converters/types/Field';

export const hintFieldValue = (field: Field): unknown => {
    if (field.selectedChoices) {
        return field.selectedChoices.map((choice) => choice.value);
    }

    if (field.selectedChoice) {
        return field.selectedChoice.value;
    }

    return field.value;
};
